import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { SuppliesComponent } from "@app/components/supplies/supplies.component";
import { GoodsComponent } from "@app/components/supplies/goods/goods.component";
import { AvailabilityComponent } from "@app/components/supplies/availability/availability.component";
import { OrganizationsComponent } from "@app/components/organizations/organizations.component";
import { ReservesComponent } from "@app/components/reserves/reserves.component";
import { RecipientsComponent } from "@app/components/recipients/recipients.component";
import { BasketComponent } from "@app/components/basket/basket.component";
import { DistributionComponent } from "@app/components/distribution/distribution.component";
import { SeriesComponent } from "@app/components/distribution/series/series.component";
import { SignDemoComponent } from "@app/components/sign-demo/sign-demo.component";
import { DistributionDozComponent } from "@app/components/distribution/doz/distributionDoz.component";
import { RefreshingComponent } from "@app/components/refreshing/refresh.component";
import { DistributionsDozComponent } from "@app/components/distributions/doz/dustributions.doz.component";
import { DistributionsMzuComponent } from "@app/components/distributions/mzu/dustributions.mzu.component";
import { BasketDozComponent } from "@app/components/distribution/doz/basket/basket.doz.component";
import {
  SubDistributionDozComponent,
} from "@app/components/distribution/doz/subDistribution/subDistributionDoz.component";
import { SeriesDozComponent } from "@app/components/distribution/doz/seriesDoz/seriesDoz.component";
import { ActionsComponent } from "@app/components/actions/actions.component";
import { PostponedComponent } from "@app/components/postponed/postponed.component";
import {SearchComponent} from "@app/components/search/search.components";

const routes: Routes = [
  {
    path: "",
    children: [
      {
        path: "",
        pathMatch: "full",
        redirectTo: "supplies",
      },
      {
        path: "supplies",
        children: [
          {
            path: "",
            component: SuppliesComponent,
            title: "Реєстр поставок",
            data: {
              breadcrumb: { alias: "Поставки" },
            },
          },
          {
            path: "supply/:supplyId",
            data: {
              breadcrumb: { alias: "Поставка" },
            },
            children: [
              {
                path: "",
                component: GoodsComponent,
              },
              {
                path: "availability/:goodId",
                component: AvailabilityComponent,
                data: {
                  breadcrumb: { alias: "Деталі товару" },
                },
              },
            ],
          },
        ],
      },
      {
        component: ReservesComponent,
        data: {
          breadcrumb: { alias: "Запаси номенклатур" },
        },
        path: "reserves",
        title: "Запаси номенклатур",
      },
      {
        path: "organizations",
        component: OrganizationsComponent,
        title: "Організації",
        data: {
          breadcrumb: { alias: "Організації" },
        },
      },
      {
        path: "recipients",
        component: RecipientsComponent,
        title: "Отримувачі",
        data: {
          breadcrumb: { alias: "Отримувачі" },
        },
      },
      {
        path: "basket",
        component: BasketComponent,
        title: "Товари обрані для розподілу",
        data: {
          breadcrumb: { alias: "Товари обрані для розподілу" },
        },
      },
      {
        path: "distribution/view/:id",
        component: DistributionComponent,
        title: "Розподіл",
        data: {
          breadcrumb: { alias: "Розподіл" },
        },
      },
      {
        path: "sub/distribution/doz/view/:id",
        component: SubDistributionDozComponent,
        title: "Дочірній розподіл",
        data: {
          breadcrumb: { alias: "Обране для розподілу" },
        },
      },
      {
        path: "distribution/series/:id",
        component: SeriesComponent,
        title: "Серії/Каталожні номери",
        data: {
          breadcrumb: { alias: "Серії/Каталожні номери" },
        },
      },
      {
        path: "sub/distribution/doz/series/:id",
        component: SeriesDozComponent,
        title: "Серії/Каталожні номери",
        data: {
          breadcrumb: { alias: "Серії/Каталожні номери" },
        },
      },
      {
        path: "distributions/doz",
        data: {
          breadcrumb: { alias: "Розподіли" },
        },
        children: [
          {
            path: "",
            component: DistributionsDozComponent,
            title: "Реєстр розподілів",
          },
          {
            path: "view/:id",
            component: DistributionDozComponent,
            title: "Розподіл",
            data: {
              breadcrumb: { alias: "Розподіл" },
            },
          },
        ],
      },
      {
        path: "distributions/mzu",
        component: DistributionsMzuComponent,
        title: "Реєстр розподілів",
        data: {
          breadcrumb: { alias: "Розподіли" },
        },
      },
      {
        path: "distribution/doz/basket",
        component: BasketDozComponent,
        title: "Товари обрані для розподілу",
        data: {
          breadcrumb: { alias: "Обране для розподілу" },
        },
      },
      {
        path: "actions",
        component: ActionsComponent,
        title: "Журнал дій",
        data: {
          breadcrumb: { alias: "Журнал дій" },
        },
      },
      {
        path: "postponed",
        component: PostponedComponent,
        title: "Відтерміновані товари",
        data: {
          breadcrumb: { alias: "Відтерміноване" },
        },
      },
      {
        path: "search",
        component: SearchComponent,
        title: "Результат пошуку",
        data: {
          breadcrumb: { alias: "Результат пошуку" },
        },
      },
      {
        path: "sign-demo",
        component: SignDemoComponent,
      },
      {
        path: "refreshing",
        component: RefreshingComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: false, useHash: true, onSameUrlNavigation: "reload", enableViewTransitions: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
